import React, { useEffect, useState } from 'react'

import { useParams } from 'react-router-dom'
import PropTypes from 'prop-types'

import { InputLabel, MenuItem, Select } from '@mui/material'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import EditIcon from '@mui/icons-material/Edit'

import InfoTile from '../components/tiles/InfoTile'
import LinkButton from '../components/LinkButton'
import config from '../config/config.json'
import useRole from '../useUserRole'

import {
  StatisticsViewPageFormControl,
  StatisticsViewPageMain,
  StatisticsViewPageTitle,
  StatisticsViewSection,
} from '../styles/pages/StatisticsViewPageStyle'
import statisticsApi from '../api/statistics'
import useHandleError from '../api/useHandleError'
import { getColumnCount, setColumnCount, setViewportWidth } from '../useViewPort'

const TILES_RELOAD_TIMER = config.tilesReloadTimer

const StatisticsViewPage = () => {
  const { id } = useParams()
  const { userRole } = useRole()
  const [infoTile, setTileInfo] = useState([])
  const [columnsPerRow, setColumnsPerRow] = useState(getColumnCount())
  const handleError = useHandleError()
  setTimeout(() => setViewportWidth())

  const getTileInfo = () => {
    return statisticsApi
      .getTile(id)
      .then((data) => data.data)
      .catch(handleError)
  }

  useEffect(() => {
    let isActive = true
    let timeoutId = null

    const fetchData = async () => {
      try {
        const info = await getTileInfo()
        if (isActive) setTileInfo(info)
      } catch (error) {
        handleError(error)
      }
      if (isActive) {
        timeoutId = setTimeout(fetchData, TILES_RELOAD_TIMER)
      }
    }

    fetchData()

    return () => {
      clearInterval(timeoutId)
      isActive = false
      timeoutId = null
    }
  }, [])

  const handleCountChange = (e) => {
    const { value } = e.target

    const correctValue = value > 0 ? value : 1

    setColumnsPerRow(correctValue)
    setColumnCount(correctValue)
  }

  const renderInfoTiles =
    infoTile?.rows && infoTile.rows.map((tile, index) => <InfoTile key={index} title={tile.name} value={tile.count} />)

  return (
    <StatisticsViewPageMain>
      <LinkButton url={'/statistics/'} icon={<ArrowBackIcon />} aria-label="goBackButton" />
      {userRole === 'admin' && <LinkButton url={`/statistics/edit/${id}`} icon={<EditIcon />} />}
      <StatisticsViewPageTitle variant="h3" component="h1">
        {infoTile.name}
      </StatisticsViewPageTitle>
      <StatisticsViewPageFormControl>
        <InputLabel>Columns</InputLabel>
        <Select
          value={columnsPerRow}
          label="Columns"
          onChange={handleCountChange}
          aria-label="columnsCount"
          variant="outlined"
        >
          {Array.from(Array(10).keys()).map((value) => (
            <MenuItem value={value + 1} key={value}>
              {value + 1}
            </MenuItem>
          ))}
        </Select>
      </StatisticsViewPageFormControl>
      <StatisticsViewSection>{renderInfoTiles}</StatisticsViewSection>
    </StatisticsViewPageMain>
  )
}

StatisticsViewPage.propTypes = {
  infoTiles: PropTypes.array,
}

export default StatisticsViewPage
